import { Component } from '@angular/core';

@Component({
  selector: 'app-exportprocessing',
  imports: [],
  templateUrl: './exportprocessing.component.html',
  styleUrl: './exportprocessing.component.scss',
})
export class ExportprocessingComponent {}
